import { z } from 'zod'

export const AuditActorSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('user'), id: z.string() }),
  z.object({ kind: z.literal('system'), id: z.string() }),
  z.object({ kind: z.literal('service'), id: z.string() }),
])
export type AuditActor = z.infer<typeof AuditActorSchema>

export const AuditActionSchema = z.enum([
  'create',
  'update',
  'delete',
  'generate',
  'render',
])
export type AuditAction = z.infer<typeof AuditActionSchema>

export const AuditResourceSchema = z.object({
  kind: z.enum(['template', 'block', 'rule', 'printer-profile', 'audit-event']),
  id: z.string(),
})
export type AuditResource = z.infer<typeof AuditResourceSchema>

export const AuditEventSchema = z.object({
  id: z.string(),
  timestamp: z.string().datetime(),
  actor: AuditActorSchema,
  action: AuditActionSchema,
  resource: AuditResourceSchema,
  before: z.unknown().optional(),
  after: z.unknown().optional(),
  etag: z.string().optional(),
  adapter: z.enum(['demo', 'embedded', 'http', 'mcp']).optional(),
})
export type AuditEvent = z.infer<typeof AuditEventSchema>
